<div
  class="group fixed left-1/2 top-4 z-50 flex w-full max-w-sm -translate-x-1/2 flex-col flex-nowrap items-stretch justify-between gap-4 rounded-2xl border pl-4 pr-4 opacity-100 shadow-[0px_2px_12px_0px_rgba(0,0,0,0.16)] transition-opacity motion-reduce:transition-none"
  [class]="toast().action ? 'pb-4 pt-4' : 'pb-3 pt-3'"
  [class.animate-toast-enter]="!toast().isExiting"
  [class.duration-250]="toast().isExiting"
  [class.ease-in]="toast().isExiting"
  [class.opacity-0]="toast().isExiting"
  [ngClass]="
    toast().type === 'success'
      ? 'h-fit border-[#185610] bg-[#D8F7D4] text-[#D8F7D4]'
      : toast().type === 'error'
        ? 'h-fit border-[#8B1A0E] bg-[#FAD5D1] text-[#FAD5D1]'
        : 'h-fit border-[#D5D6DC] bg-white text-[#515561] [box-shadow:0px_2px_12px_0px_rgba(0,0,0,0.16)]'
  "
>
  <div class="flex flex-row flex-nowrap items-start justify-between gap-2.5">
    <div
      class="flex h-fit flex-1 flex-row flex-wrap items-start justify-start pb-0 pl-0 pr-0 pt-0 text-left text-sm font-normal leading-[19.6px] tracking-normal"
      [class]="
        toast().type === 'success'
          ? 'fill-[#185610] text-[#185610]'
          : toast().type === 'error'
            ? 'fill-[#8B1A0E] text-[#8B1A0E]'
            : 'fill-[#515561] text-[#515561]'
      "
    >
      {{ toast().message }}
    </div>
    @if (toast().dismissible !== false) {
      <button
        class="flex h-[20px] w-[20px] flex-shrink-0 flex-row flex-nowrap items-center justify-center pb-0 pl-0 pr-0 pt-0"
        (click)="dismissed.emit(toast().id)"
      >
        <svg-icon
          [src]="'svgs/close_20x.svg'"
          [svgClass]="
            toast().type === 'success'
              ? 'pl-0 pr-0 pt-0 pb-0 flex-wrap flex flex-row items-start justify-start h-[20px] w-[20px] fill-[#185610]'
              : toast().type === 'error'
                ? 'pl-0 pr-0 pt-0 pb-0 flex-wrap flex flex-row items-start justify-start h-[20px] w-[20px] fill-[#8B1A0E]'
                : 'pl-0 pr-0 pt-0 pb-0 flex-wrap flex flex-row items-start justify-start h-[20px] w-[20px] fill-[#696E7E]'
          "
        ></svg-icon>
      </button>
    }
  </div>
  @if (toast().action) {
    <div class="flex w-full flex-row justify-end">
      <app-button
        [label]="toast().action?.text ?? 'Click'"
        [width]="'fit'"
        [size]="'small'"
        (buttonClicked)="actionClicked.emit(toast())"
      ></app-button>
    </div>
  }
</div>
